import { render, staticRenderFns } from "./LKAsideMenuSubmenuHeader.vue?vue&type=template&id=4b1b0d5d&"
import script from "./LKAsideMenuSubmenuHeader.vue?vue&type=script&lang=js&"
export * from "./LKAsideMenuSubmenuHeader.vue?vue&type=script&lang=js&"
import style0 from "./LKAsideMenuSubmenuHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports